import { render, staticRenderFns } from "./costHelpSixtyTage.vue?vue&type=template&id=907240ec&"
import script from "./costHelpSixtyTage.vue?vue&type=script&lang=js&"
export * from "./costHelpSixtyTage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('907240ec')) {
      api.createRecord('907240ec', component.options)
    } else {
      api.reload('907240ec', component.options)
    }
    module.hot.accept("./costHelpSixtyTage.vue?vue&type=template&id=907240ec&", function () {
      api.rerender('907240ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-277ZPZNvk99Jx/JS/costHelpSixtyTage.vue"
export default component.exports